module.exports = __webpack_public_path__ + "img/logo_light.e48aba0e.png";